import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_REVISION } from '../../../../Constants';

export const useCreateMediaAccess = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createMediaAccessHook = async (revision_access, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_REVISION}`,
        {revision_access}
      );

      const status = response?.status;
      if (status === 200) {
        setSuccess(true);
        handleUpdate();
      } else {
        setError("Failed to create media access");
      }
    } catch (error) {
      setError("An error occurred while creating the media access");
    } finally {
      setLoading(false);
    }
  };

  return [ createMediaAccessHook, loading, error, success ];
};